import { customAxios, IDUSUARIO, USERNAME, FDV_URL, ENTREGAS_URL } from '../constants';
import { FETCH_HISTORIAL, FETCH_HISTORIAL_FDV, FETCH_GRABAR_HISTORIAL_FDV, FETCH_TIPO_ACTIVIDAD, FETCH_EVENTO_ACTIVIDAD } from './types';
import { evalAction, serverError } from '../utils/actionError';


export function fetchHistorial(id) {
  const config = {
    params: {
      codigo: id,
    },
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const request = customAxios.get(`${ENTREGAS_URL}/entrega-vehiculo/planificaciones/${id}/historiales`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_HISTORIAL,
    payload: request,
  };
}

export function fetchHistorialFDV(fdvID, fechInicio = '', fechFinal = '' , numPedidoVeh = '', numProfVeh = '', codTiAct = '', nroPag = '1') {
  const config = {
    params: {
      fechInicio,
      fechFinal,
      numPedidoVeh,
      numProfVeh,
      codTiAct
    },
    headers: {
      indPaginado: 'S',
      nroPag,
      cantidadxPag:'10'
    },
  };

  const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/${fdvID}/eventos`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_HISTORIAL_FDV,
    payload: request,
  };
}

export function fetchGrabarHistorialFDV(fdvID, asunto, coUsuarioDest, codTipAct, contenido, dirCorreo, indEnvioCorreo,
                    numCorrelativoPadre, numRegiRela, tipoEvento, tipoRegiRela) {

  const config = {
    headers: {
      idUsuario: IDUSUARIO,
      codUsuario: USERNAME,
    }
  };

  const data = {
    asunto: asunto,
    coUsuarioDest: coUsuarioDest,
    codTipAct: codTipAct,
    contenido: contenido,
    dirCorreo: dirCorreo,
    indEnvioCorreo: indEnvioCorreo,
    numCorrelativoPadre: (+fdvID *1) + '05',
    numRegiRela: numRegiRela,
    tipoEvento: tipoEvento,
    tipoRegiRela: tipoRegiRela
  }

  const request = customAxios.post(`${FDV_URL}/ficha-venta/fichas-venta/${fdvID}/eventos`,data, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_GRABAR_HISTORIAL_FDV,
    payload: request,
  };
}


export function fetchTipoActividad() {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
      codUsuario: USERNAME,
      indPaginado: 'S',
      nroPag:'1',
      cantidadxPag:'10'
    }
  };

  const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/tipo-actividad/eventos`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_TIPO_ACTIVIDAD,
    payload: request,
  };
}

export function fetchEventoActividad(fdvID) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
      codUsuario: USERNAME
    }
  };

  const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/lista-evento-actividad/${fdvID}/eventos`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_EVENTO_ACTIVIDAD,
    payload: request,
  };
}





// WEBPACK FOOTER //
// ./src/actions/Historial.js